export default theme => ({
  sbomDownloader: {
    marginLeft: 'auto',
    marginRight: theme.spacing(19.5)
  },
  downloadButton: {
    textTransform: 'none',
    height: theme.spacing(4.5)
  },
  addComponentButton: {
    marginLeft: 'auto',
    marginRight: theme.spacing(1.5)
  }
});
